import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BlocActualite = () => {
  const [actualites, setActualites] = useState([]); // État pour stocker les actualités
  const Url = process.env.REACT_APP_URL_DEV;
  console.log('url', Url);

  useEffect(() => {
    axios
      .get(`${Url}/api/actualites/all`) // Endpoint des actualités
      .then((response) => {
        const sortedData = response.data.data.sort(
          (a, b) => new Date(b.actualitesDate) - new Date(a.actualitesDate),
        );
        setActualites(sortedData);
        console.log('Données reçues', sortedData);
      })
      .catch((error) => {
        console.error(
          'Erreur lors de la récupération des actualités:&apos;, error',
        );
      });
  }, []);

  return (
    <div className="blog-container">
      {/* Section principale */}
      <div className="main-content">
        <div className="blog-area" style={{ display: 'block' }}>
          <div className="row">
            {actualites.map((actualite) => (
              <div
                className="col-md-4 col-sm-12 col-lg-3 mt-3"
                key={actualite.actualitesId}
              >
                <div className="single-blog-inner1">
                  <div className="thumb">
                    <img
                      src={`${Url}/images/${actualite.actualitesImage}`} // Image depuis le backend
                      alt={actualite.actualitesTitre}
                    />
                  </div>
                  <div className="details">
                    <h5 style={{ height: '50px' }}>
                      {actualite.actualitesTitre}
                    </h5>
                    <Link
                      className="read-more-text"
                      to={`/actualite-detail/${actualite.actualitesId}`}
                    >
                      <h6>Voir Le Document</h6>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="sidebar">
        <h4>Derniers Articles</h4>
        <ul className="latest-articles">
          {actualites.map((actualite) => (
            <li key={actualite.actualitesId}>
              <Link to={`/actualite-detail/${actualite.actualitesId}`}>
                {actualite.actualitesTitre}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BlocActualite;
